import { ReportDesignerHostComponent } from "../../report-designer-host/report-designer-host.component";
import { PrintServiceBase } from "./print-service-base";
import { PrintService } from "./print.service";

/**
 * Load and then print service
 */
export class LoadThenPrintService extends PrintServiceBase implements PrintService {
  /**
   * Page waits for print?
   */
  readonly pageWaitsForPrint = false;

  /**
   * Raise CSS print events?
   */
  readonly raiseCssPrintEvents = true;

  /**
   * Initialization logic
   * @param host RD host
   */
  init(host: ReportDesignerHostComponent): void {
    this.host = host;
    this.document = this.rdStorage.getActiveDocument();
    this.pages = this.document.data.pages;

    this.pages = this.getPrintablePages();
    if (this.pages.length === 0) {
      //nothing to print => inform app/puppeteer that there is nothing to print
      this.host.raisePrintEvent('pdf-export-finished');
    }
  }

  /**
   * Process the queue
   */
  protected processQueue(): void {
    //nothing to do
  }

  /**
   * Batch pages
   */
  protected batchPagesForPrint(): void {
    //nothing to do
  }

  /**
   * Page data loaded callback
   * @param page The page component
   */
  pageDataLoaded(): void {
    //nothing to do
  }

  /**
   * Cocument data loaded callback -> report is loaded
   */
  documentDataLoaded(): void {
    //prevent multiple calls
    if (!this.documentDataLoadedProcessed) {
      this.documentDataLoadedProcessed = true;
      this.host.documentDataLoaded();
    }
  }
}
